export const DEFAULT_API_RESULTS_PER_PAGE = 250;
